import { graphql } from '../../../graphql/generated';

export const LabFragment = graphql(`
  fragment DoctorForm_Lab on Lab {
    id
    name
    aiEnabled
  }
`);

export const ThemeFragment = graphql(`
  fragment DoctorForm_Theme on Theme {
    id
    name
  }
`);

export const CatalogFragment = graphql(`
  fragment DoctorForm_Catalog on Catalog {
    id
    name
    lab {
      id
      shortName
    }
  }
`);

export const InsuranceFragment = graphql(`
  fragment DoctorForm_Insurance on Insurance {
    id
    name
    shortName
    code
  }
`);

export const SpecialRateFragment = graphql(`
  fragment DoctorForm_SpecialRate on SpecialRate {
    id
    name
    shortName
    lab {
      id
      shortName
    }
  }
`);

export const TagFragment = graphql(`
  fragment DoctorForm_Tag on Tag {
    id
    name
    color
  }
`);
